import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./messPlans.css";

export default function MessPlans() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [plans, setPlans] = useState([]);
  const [hostels, setHostels] = useState([]);

  const [hostel, setHostel] = useState("");
  const [vegPrice, setVegPrice] = useState("");
  const [nonVegPrice, setNonVegPrice] = useState("");

  const year = new Date().getFullYear();

  useEffect(() => {
    loadHostels();
    loadPlans();
  }, []);

  const loadHostels = async () => {
    const res = await API.get("/school-admin/hostels/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setHostels(res.data.hostels || []);
  };

  const loadPlans = async () => {
    const res = await API.get("/school-admin/hostel/mess/plans/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setPlans(res.data.plans || []);
  };

  const onlyNumber = (v) => v.replace(/[^0-9]/g, "");

  const addPlan = async () => {
    if (!hostel || !vegPrice || !nonVegPrice) {
      alert("Please fill all fields");
      return;
    }

    await API.post(
      "/school-admin/hostel/mess/plans/create/",
      {
        hostel,
        year,
        veg_price: parseInt(vegPrice),
        nonveg_price: parseInt(nonVegPrice),
      },
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );

    setVegPrice("");
    setNonVegPrice("");
    setHostel("");
    loadPlans();
  };

  const deletePlan = async (id) => {
    if (!window.confirm("Delete this mess plan?")) return;

    await API.delete(`/school-admin/hostel/mess/plans/${id}/delete/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });

    loadPlans();
  };

  return (
    <div className="mess-page">
      <h2>🍽 Yearly Mess Plans</h2>

      {/* ADD PLAN */}
      <div className="mess-add-card">
        <select value={hostel} onChange={(e) => setHostel(e.target.value)}>
          <option value="">Select Hostel</option>
          {hostels.map((h) => (
            <option key={h.id} value={h.id}>
              {h.name}
            </option>
          ))}
        </select>

        <input
          placeholder="Veg Price (Yearly)"
          value={vegPrice}
          onChange={(e) => setVegPrice(onlyNumber(e.target.value))}
        />

        <input
          placeholder="Non-Veg Price (Yearly)"
          value={nonVegPrice}
          onChange={(e) => setNonVegPrice(onlyNumber(e.target.value))}
        />

        <button onClick={addPlan}>Add Plan</button>
      </div>

      {/* LIST */}
      <div className="mess-grid">
        {plans.length === 0 && <p>No mess plans added yet.</p>}

        {plans.map((p) => (
          <div key={p.id} className="mess-card">
            <div className="mess-card-header">
              <h3>{p.hostel_name}</h3>
              <span className={p.is_active ? "active" : "inactive"}>
                {p.is_active ? "ACTIVE" : "INACTIVE"}
              </span>
            </div>

            <div className="mess-prices">
              <div>
                <label>Veg</label>
                <strong>₹{p.veg_price}</strong>
              </div>
              <div>
                <label>Non-Veg</label>
                <strong>₹{p.nonveg_price}</strong>
              </div>
            </div>

            <div className="mess-footer">
              <span>Year: {p.year}</span>
              <button className="danger" onClick={() => deletePlan(p.id)}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}